import styled from 'styled-components/macro';

const GrayTxt = styled.span`
  margin-left: ${props => (props.right ? '13px' : 0)};
  font-size: 14px;
  color: #fff;
  opacity: 0.6;
`;

export default GrayTxt;
